/**
 * @providesModule CurrencyController
 * Currency flows
 */

import ClientPropertyConstants from 'ClientPropertyConstants'; 
import CurrencyAPIManager from 'CurrencyAPIManager';
import I18n, {CurrencyCode} from 'INTL';
import {SKZUserInterface} from 'SKZUser';
 
class CurrencyController {
  private updateI18n(currency: CurrencyCode) {
    const locale = currency === 'INR' ? 'en-IN' : I18n.getDeviceLocale();
    console.debug(`INTL updateI18n currency: ${currency}, locale: ${locale} called from ${this.updateI18n?.caller?.name}`);
    I18n.setCurrencyAndLocale(currency, locale);
  }

  /**
   * Calls v1/user-currency and sets the returned value in I18n. 
   * In case of any network errors, it will prompt the user to retry until it works or they press cancel.
   * @param currentUser the native user passed as a prop to SkillzSDK
   */
  async fetchUserCurrency(currentUser: SKZUserInterface, canUseCache: boolean): Promise<void> {
    if (!currentUser) {
      throw new Error('fetchUserCurrency called with no currentUser');
    }
    try {
      const currency = await CurrencyAPIManager.getUserCurrency(canUseCache);
      this.updateI18n(currency);
    } catch (e) {
      console.log('user currency fetch failed');
    }
  }

  /**
   * Calls POST v1/user-currency and updates the returned value in I18n. 
   * In case of any network errors, it will prompt the user to retry until it works or they press cancel.
   * @param currentUser the native user passed as a prop to SkillzSDK
   */
  async updateUserCurrency(currentUser: SKZUserInterface, currency: CurrencyCode): Promise<void> {
    if (!currentUser) {
      throw new Error('updateUserCurrency called with no currentUser');
    }
    try {
      await CurrencyAPIManager.postUserCurrency(currency);
    } catch (e) {
      console.log('user currency update failed');
    }
    this.updateI18n(currency);
  }

  shouldDisplayCountrySelection() {
    return ClientPropertyConstants.getFtueCurrencyPromptEnabled();
  }
  
  isUSD(): boolean {
    return I18n.currentCurrency() === 'USD';
  }
}

export default new CurrencyController();
